import "./SkeletonSmall.css";

const SkeletonSmallItem = () => (
  <div className="skeleton-small-card">
    <div className="skeleton-small-line title" />
    <div className="skeleton-small-line" />
  </div>
);

const SkeletonSmall = ({ count = 4 }) => {
  const items = Array.from({ length: count });
  return (
    <div className="skeleton-small-list">
      {items.map((_, i) => (
        <div key={i} className="skeleton-small-col">
          <SkeletonSmallItem />
        </div>
      ))}
    </div>
  );
};

export default SkeletonSmall;
